import { useTranslation } from 'react-i18next'

import { useOptionalAtom } from '@root/shared/lib'
import { PremiumAlert } from '@root/shared/ui'

import type { CurrencySafetyCheck } from '../../atoms'
import type { ClassNameProps } from '@root/shared/react'
import type { PremiumAlertProps } from '@root/shared/ui'

type CheckCurrencyAlertProps = {
  result: CurrencySafetyCheck
} & ClassNameProps

export const CheckCurrencyAlert: React.FC<CheckCurrencyAlertProps> = ({
  result,
  className,
}) => {
  const { t } = useTranslation()
  const premium = useOptionalAtom(result.premiumInfo?.premium)
  const renderMessage = () => {
    if (premium) {
      return t('premium.check.alert.active')
    }
    return result.hasPassedSecurityChecks
      ? t('premium.check.alert.passed')
      : t('premium.check.alert.failed')
  }

  const intent = ((): PremiumAlertProps['intent'] => {
    if (premium) {
      return 'premium'
    }
    return result.hasPassedSecurityChecks ? 'success' : 'error'
  })()

  return (
    <PremiumAlert className={className} intent={intent}>
      {renderMessage()}
    </PremiumAlert>
  )
}
